module.exports = __webpack_public_path__ + "img/proagria-lansi-suomi.f1fb6476.png";